import { Component, h } from "preact";
import { DashListings } from "./dash-listings.component";
import { route } from 'preact-router';

interface GroupListingsProps {
  group?: string;
}

export class GroupListings extends Component<GroupListingsProps> {
  render(props, state) {
    return (
      <DashListings groupProfile={ props.group }/>
    )
  }
}
